<template>
  <div class="float-window">
    <!-- <div class="module-item">
      <div class="button-box" @click="setCloudRegisterPopup(true)">
        <img class="button-icon" src="@/assets/img/layout/FloatWindow/icon_zcyqy.png">
        <div class="button-name">注册云企业</div>
      </div>
    </div> -->
    <div class="module-item relative">
      <div class="button-box">
        <img class="button-icon" src="@/assets/img/layout/FloatWindow/icon_dhzx.png">
        <div class="button-name">电话咨询</div>
      </div>
      <HotlineDialog />
    </div>
    <div class="module-item">
      <div class="button-box" ref="aiBtnRef" @click="$refs.AIDialogRef.open()">
        <img class="button-icon" src="@/assets/img/layout/FloatWindow/icon_znai.png">
        <div class="button-name">智能AI</div>
      </div>
      <AIDialog ref="AIDialogRef" />
    </div>
    <div class="module-item" ref="commentBtnRef" @click="$refs.CommentDialogRef.open()">
      <div class="button-box">
        <img class="button-icon" src="@/assets/img/layout/FloatWindow/icon_wydp.png">
        <div class="button-name">我要点评</div>
      </div>
      <CommentDialog ref="CommentDialogRef" />
    </div>
    <transition name="fade">
      <div class="back-top" @click="backTop" v-if="showTop">
        <img class="button-icon" src="@/assets/img/layout/FloatWindow/icon_top.png">
        <div class="button-name">返回顶部</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import HotlineDialog from './HotlineDialog.vue';
import AIDialog from './AIDialog.vue';
import CommentDialog from './CommentDialog.vue';

export default {
  components: {
    HotlineDialog,
    AIDialog,
    CommentDialog
  },
  data() {
    return {
      showTop: false,
      commentRelative: true,
    }
  },
  mounted() {
    document.body.addEventListener('click', this.handleClick);
    document.addEventListener('scroll', this.handleScroll);
    setTimeout(() => {
      this.isRelative = false;
    }, 3000);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handleClick);
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(['setCloudRegisterPopup']),
    handleClick(e) {
      // 关闭AI弹窗
      if (!this.$refs.aiBtnRef.contains(e.target)) {
        this.$refs.AIDialogRef.close();
      }
      // 关闭点评弹窗
      if (!this.$refs.commentBtnRef.contains(e.target)) {
        this.$refs.CommentDialogRef.close();
      }
    },
    handleScroll() {
      this.showTop = window.scrollY > 200;
    },
    backTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style lang="less" scoped>
.float-window {
  padding: 14px 4px;
  background-color: #fff;
  box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  position: fixed;
  top: 50%;
  right: 26px;
  z-index: 100;
  transform: translateY(-50%);
  .module-item {
    &.relative {
      position: relative;
    }
    + .module-item {
      margin-top: 14px;
    }
    .button-box {
      width: 78px;
      height: 64px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.2s;
      .button-icon {
        width: 32px;
        height: 32px;
        margin-bottom: 2px;
      }
      .button-name {
        font-size: 14px;
      }
      &:hover {
        background-color: @primary-color;
        .button-icon {
          filter: brightness(0) invert(1);
        }
        .button-name {
          color: #fff;
        }
        // 显示热线弹窗
        + .hotline-dialog {
          display: block;
        }
      }
    }
  }

  .back-top {
    width: 86px;
    height: 64px;
    background-color: #fff;
    box-shadow: 0px 0px 13px 0px rgba(0,0,0,0.1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: -14px;
    transform: translateY(100%);
    transition: 0.2s;
    cursor: pointer;
    .button-icon {
      width: 32px;
      height: 32px;
      margin-bottom: 2px;
    }
    .button-name {
      font-size: 14px;
    }
    &:hover {
      background-color: @primary-color;
      .button-icon {
        filter: brightness(0) invert(1);
      }
      .button-name {
        color: #fff;
      }
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
